'use strict';
angular
    .module('dnapp')
    .controller('DNDepartments.ResetUmbracoController', ['DNDepartments.ResetUmbracoPasswordService', '$sce', '$location', function (dataService, $sce, $location) {
        var vm = this;
        vm.userName = null;

        vm.newPassword = null;
        vm.newPasswordConfirm = null;

        vm.landingPage = false;

        vm.success = false;
        vm.message = "";
        vm.messageType = "";

        if (!$.isEmptyObject($location.search()) && $location.search().l.length && $location.search().g.length) {
            dataService.checkGuid({ userLogin: $location.search().l, guid: $location.search().g }).$promise.then(function (response) {
                if (response.Success) {
                    vm.landingPage = true;
                } else {
                    if (response.ErrorMessage === "Expired") {
                        vm.success = false;
                        vm.message = "<strong>INFO:</strong> Dit link er udløbet. Bestil et nyt.";
                        vm.messageType = "reset-umb-password--info";
                    } else if (response.ErrorMessage === "No guid") {
                        vm.success = false;
                        vm.message = "<strong>INFO:</strong> GUID findes ikke.";
                        vm.messageType = "reset-umb-password--info";
                    }
                }
            });
        }

        vm.requestPasswordReset = function () {
            if (vm.userName != null && vm.userName.length) {
                dataService.resetPassword({ UserLogin: vm.userName }).$promise.then(function (response) {
                    if (response.Success) {
                        vm.success = true;
                        vm.message = "<strong>INFO:</strong> Vi har sendt dig et gendannelseslink.";
                        vm.messageType = "reset-umb-password--success";
                    } else {
                        vm.success = false;

                        if (response.ErrorMessage != null && response.ErrorMessage !== "ERROR: No User exists with ID -1") {
                            console.log(response.ErrorMessage);
                        } else {
                            vm.message = "<strong>INFO:</strong> Ingen bruger med det brugernavn.";
                            vm.messageType = "reset-umb-password--info";
                        }
                    }
                });
            } else {
                vm.success = false;
                vm.message = "<strong>INFO:</strong> Du har ikke udfyldt et brugernavn.";
                vm.messageType = "reset-umb-password--info";
            }
        }

        vm.setNewPassword = function () {
            if (vm.newPassword != null && vm.newPassword.length && vm.newPasswordConfirm != null && vm.newPasswordConfirm.length) {
                var isSame = vm.newPassword === vm.newPasswordConfirm;

                if (isSame) {
                    dataService.setNewPassword({ userLogin: $location.search().l, guid: $location.search().g, newPassword: vm.newPassword }).$promise.then(function (response) {
                        if (response.Success) {
                            vm.success = true;
                            vm.message = "<strong>INFO:</strong> Ny kode gemt. <a href=\"/umbraco\">Gå til login</a>";
                            vm.messageType = "reset-umb-password--success";
                        } else {
                            if (response.ErrorMessage === "No guid") {
                                vm.success = false;
                                vm.message = "<strong>INFO:</strong> Der er sket en fejl. Prøv igen.";
                                vm.messageType = "reset-umb-password--info";
                            }
                        }
                    });
                } else {
                    vm.success = false;
                    vm.message = "<strong>INFO:</strong> Koderne er ikke ens.";
                    vm.messageType = "reset-umb-password--info";
                }
            } else {
                vm.success = false;
                vm.message = "<strong>INFO:</strong> Du har ikke udfyldt et felt.";
                vm.messageType = "reset-umb-password--info";
            }
        }
    }]);